import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { TableCDS } from 'app/shared/componentsRestyled/coreDesignSystem/Table';
import _ from 'lodash';

import { selectClosingAmortizationSchedule } from 'store/loanApplications/selectors';

import { getTableConfig } from './AmortizationScheduleTable.config';
import { tableCustomStyles } from './AmortizationScheduleTable.styles';
import { getFormattedTableData } from './AmortizationScheduleTable.utils';

const AmortizationScheduleTable = () => {
  const amortizationSchedule = useSelector(selectClosingAmortizationSchedule);
  const { estimatedPayments, isBuyDown } = amortizationSchedule;

  const isLoading = _.isEmpty(amortizationSchedule);

  const tableConfig = useMemo(() => getTableConfig({ isBuyDown }), [isBuyDown]);

  const tableData = useMemo(() => getFormattedTableData(estimatedPayments), [estimatedPayments]);

  return (
    <TableCDS
      isStickyHeader
      config={tableConfig}
      customStyles={tableCustomStyles}
      data={tableData}
      isLoading={isLoading}
      testId="amortization-schedule-table"
      withDivider={false}
    />
  );
};

export default AmortizationScheduleTable;
